// components/portal/portalTheme.ts
'use client';

export const portalViewWrapper =
  'flex h-full w-full flex-col overflow-hidden text-white';

export const portalScrollableContent =
  'flex-1 overflow-y-auto custom-scrollbar';

export const portalCard =
  'rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-xl shadow-[0_25px_80px_rgba(0,0,0,0.35)]';

export const portalInput =
  'h-11 rounded-2xl border border-white/10 bg-white/[0.02] px-4 text-sm text-white placeholder-white/40 focus:border-white/50 focus:outline-none focus:ring-0';

export const portalFilterButton =
  'flex items-center gap-2 h-11 px-4 rounded-2xl border border-white/10 bg-white/[0.02] text-sm text-white/70 transition-colors hover:bg-white/[0.05] hover:text-white';

export const portalSectionTitle =
  'text-xs font-medium text-white/50';

export const portalPill =
  'rounded-full border border-white/10 bg-white/[0.02] px-3 py-1 text-xs text-white/70';

export const portalTableRow =
  'border-b border-white/5 text-sm text-white transition-colors bg-white/[0.04] hover:bg-white/[0.08]';

export const getScoreColorClass = (score: number | null | undefined) => {
  if (score === null || score === undefined) return 'text-white/30';
  if (score < 30) return 'text-white/35';
  if (score < 60) return 'text-white/50';
  if (score < 80) return 'text-white/70';
  return 'text-white/90';
};

export const getUnitStatusHex = (status: string | null | undefined) => {
  const colors = {
    AVAILABLE: '#4DAB9A',
    UNDER_OFFER: '#529CCA',
    LEASED: '#979A9B',
    EXPIRING_SOON: '#FFA344',
    REPLACEMENT_UNDER_OFFER: '#9A6DD7'
  };
  if (!status) return colors.AVAILABLE;
  return colors[status as keyof typeof colors] || colors.LEASED;
};
